import StudyList from './StudyList';

export default StudyList;
